/** One attempt per mounted page and context, including rejected requests. */
export function createCommissionReloadGuard() {
  let lastAttempt: string | undefined;
  return (key: string, isCalculating: boolean) => {
    if (isCalculating || key === lastAttempt) return false;
    lastAttempt = key;
    return true;
  };
}
